import React, { useState, useEffect } from 'react'
import { set, useForm } from 'react-hook-form';
import axios from 'axios'
import { Link } from 'react-router-dom';
import LoadingBar from 'react-top-loading-bar'

import styles from '../../App.module.css'
import classes from './ForgotPassword.module.css'

function ForgotPassword() {
    const { register, handleSubmit, formState: { errors } } = useForm();
    const [msg, setMsg] = useState({
        'status': '',
        'message': ''
    })
    const [progress, setProgress] = useState(100);

    const onSubmit = (data) => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/forgotpassword.php`, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }).then(res => {
                console.log(res.data);
                setMsg({
                    status: res.data.status,
                    message: res.data.message
                })
            }).catch(err => {
                console.log(err);
            })
    }

    return (
        <>
            <LoadingBar
                color='#f11946'
                progress={progress}
                onLoaderFinished={() => setProgress(0)}
            />
            <div className={classes.main_body}>
                <div className={classes.main_content}>
                    <div className={classes.box_wrapper}>
                    {
                        msg.status !== '' && msg.message !== '' && <div className={`alert alert-${msg.status} mb-5`} role="alert">
                        {msg.message}
                      </div>
                    }
                        <div className={classes.content}>
                            <h3>Recover password</h3>
                            <p className='text-muted'>Recover your password by e-mail. <br /> If you've used an social service, just click on the button for that service on the login page.</p>
                        </div>
                        <div className={classes.form}>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <input {...register('forgot-pass')} type="hidden" value="1" />
                                <input {...register('remail')} className="form-control" type="email" placeholder="Email address" />
                                <div className={classes.btn}>
                                    <button className="btn btn-large btn-primary" type="submit">Recover</button>
                                    <Link to="/login">&lt; Back to login</Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ForgotPassword